import { keyToUrl } from '@tools/common'

export const depotsKeys = {
  root: (companyId?: number) => ['depots', companyId ?? null] as const,
  depot: (id: number) => ['depots', id] as const,
}

export const depotsUrls = {
  root: keyToUrl(depotsKeys.root()),
  depot: (id: number) => keyToUrl(depotsKeys.depot(id)),
}
